import { useMemo } from 'react';

import AIJobProgressLoader from 'components/ai/AIJobProgressLoader';
import SlideoutLoaderContainer from 'components/shared/ai/SlideoutLoaderContainer';
import TimingExplainer from 'components/shared/ai/TimingExplainer';
import { useStageTimer } from 'hooks/useStageTimer';
import AIJob from 'models/AIJob';

type ComparisonLoadingStateProps = {
  comparisonJob: AIJob | null;
  onLoadingFinished: () => void;
};

export default function ComparisonLoadingState({ comparisonJob, onLoadingFinished }: ComparisonLoadingStateProps) {
  const comparisonJobCreatedAt = comparisonJob?.createdAt;

  const onSecondStage = useStageTimer(comparisonJobCreatedAt, 30);
  const onThirdStage = useStageTimer(comparisonJobCreatedAt, 60);

  const stage = useMemo(() => {
    if (comparisonJob?.isCompleted) {
      return 4;
    }
    if (onThirdStage) {
      return 3;
    }
    if (onSecondStage) {
      return 2;
    }
    return 1;
  }, [comparisonJob, onSecondStage, onThirdStage]);

  const stages = useMemo(
    () => [{ title: 'Comparing summaries' }, { title: 'Formatting comparison' }, { title: 'Finishing up' }],
    []
  );

  return (
    <SlideoutLoaderContainer>
      <AIJobProgressLoader
        title='Generating Comparison'
        subtitle='Comparing and identifying changes between summaries'
        stages={stages}
        stage={stage}
        onLoadingFinished={onLoadingFinished}
      />
      <TimingExplainer jobType='comparison' />
    </SlideoutLoaderContainer>
  );
}
